var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2633_7616)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2.16992,
    width: 54,
    height: 54,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 2.66992,
    width: 53,
    height: 53,
    rx: 3.5,
    stroke: "black",
    strokeOpacity: 0.12,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7421 30.0803C32.6927 30.0801 32.6439 30.0897 32.5983 30.1085C32.5527 30.1273 32.5113 30.1549 32.4764 30.1898C32.4416 30.2246 32.4139 30.2661 32.3951 30.3116C32.3764 30.3572 32.3668 30.4061 32.3669 30.4554V37.9237H35.8592V30.4554C35.8594 30.4061 35.8498 30.3572 35.831 30.3116C35.8122 30.2661 35.7846 30.2246 35.7497 30.1898C35.7148 30.1549 35.6734 30.1273 35.6278 30.1085C35.5822 30.0897 35.5334 30.0801 35.4841 30.0803H32.7421Z",
    fill: "url(#paint0_linear_2633_7616)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4781 28.955V37.9238H39.9703V28.955C39.9705 28.9057 39.9609 28.8568 39.9421 28.8113C39.9233 28.7657 39.8957 28.7242 39.8608 28.6894C39.826 28.6545 39.7846 28.6269 39.739 28.6081C39.6934 28.5893 39.6445 28.5797 39.5952 28.5799H36.8532C36.8039 28.5797 36.755 28.5893 36.7094 28.6081C36.6639 28.6269 36.6224 28.6545 36.5876 28.6894C36.5527 28.7242 36.5251 28.7657 36.5063 28.8113C36.4875 28.8568 36.4779 28.9057 36.4781 28.955Z",
    fill: "url(#paint1_linear_2633_7616)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.516 33.0811C24.4667 33.081 24.4178 33.0906 24.3722 33.1094C24.3266 33.1281 24.2852 33.1558 24.2504 33.1906C24.2155 33.2255 24.1879 33.2669 24.1691 33.3125C24.1503 33.3581 24.1407 33.4069 24.1409 33.4563V37.9238H27.6331V33.4563C27.6333 33.4069 27.6237 33.3581 27.6049 33.3125C27.5861 33.2669 27.5585 33.2255 27.5236 33.1906C27.4888 33.1558 27.4473 33.1281 27.4017 33.1094C27.3562 33.0906 27.3073 33.081 27.258 33.0811H24.516Z",
    fill: "url(#paint2_linear_2633_7616)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4048 34.5403C20.3555 34.5401 20.3066 34.5497 20.261 34.5685C20.2154 34.5873 20.174 34.6149 20.1391 34.6498C20.1043 34.6846 20.0767 34.7261 20.0579 34.7716C20.0391 34.8172 20.0295 34.8661 20.0297 34.9154V37.9237H23.5219V34.9154C23.5221 34.8661 23.5125 34.8172 23.4937 34.7716C23.4749 34.7261 23.4473 34.6846 23.4124 34.6498C23.3776 34.6149 23.3361 34.5873 23.2905 34.5685C23.245 34.5497 23.1961 34.5401 23.1468 34.5403H20.4048Z",
    fill: "url(#paint3_linear_2633_7616)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6309 31.5807C28.5815 31.5803 28.5325 31.5896 28.4867 31.6083C28.441 31.627 28.3995 31.6546 28.3645 31.6895C28.3296 31.7244 28.302 31.766 28.2833 31.8117C28.2646 31.8575 28.2553 31.9064 28.2558 31.9558V37.9237H31.7443V31.9558C31.7447 31.9064 31.7354 31.8574 31.7167 31.8117C31.698 31.766 31.6704 31.7244 31.6355 31.6895C31.6005 31.6546 31.559 31.627 31.5133 31.6083C31.4675 31.5896 31.4185 31.5802 31.3692 31.5807H28.6309Z",
    fill: "url(#paint4_linear_2633_7616)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1279 38.674H19.8722C19.7737 38.6755 19.6798 38.7157 19.6107 38.7859C19.5417 38.8561 19.5029 38.9506 19.5029 39.0491C19.5029 39.1475 19.5416 39.2421 19.6107 39.3123C19.6798 39.3824 19.7737 39.4226 19.8721 39.4242H40.1279C40.1772 39.4244 40.2261 39.4148 40.2718 39.396C40.3174 39.3772 40.3589 39.3496 40.3939 39.3148C40.4288 39.2799 40.4566 39.2385 40.4755 39.1929C40.4944 39.1473 40.5041 39.0984 40.5041 39.0491C40.5041 38.9997 40.4944 38.9509 40.4755 38.9053C40.4566 38.8597 40.4288 38.8183 40.3939 38.7834C40.3589 38.7486 40.3174 38.721 40.2718 38.7022C40.2261 38.6834 40.1772 38.6738 40.1279 38.674Z",
    fill: "url(#paint5_linear_2633_7616)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1438 31.1606C21.0512 31.1823 20.9704 31.2382 20.9175 31.3172C20.8646 31.3962 20.8437 31.4923 20.8589 31.5861C20.8742 31.6799 20.9244 31.7644 20.9996 31.8226C21.0747 31.8808 21.1692 31.9083 21.2638 31.8995C26.943 31.378 32.3659 29.2899 36.9282 25.8679L37.4121 26.3743C37.4571 26.4226 37.5143 26.4578 37.5777 26.4763C37.6411 26.4948 37.7083 26.4958 37.7722 26.4793C37.8369 26.4644 37.8964 26.4321 37.944 26.3858C37.9916 26.3395 38.0256 26.281 38.0423 26.2167L39.1338 22.3381C39.1506 22.2745 39.1505 22.2076 39.1336 22.144C39.1167 22.0804 39.0835 22.0222 39.0374 21.9753C38.9912 21.9284 38.9337 21.8943 38.8703 21.8764C38.807 21.8584 38.7401 21.8573 38.6762 21.873L34.7789 22.897C34.7162 22.9145 34.6592 22.9479 34.6133 22.9939C34.5673 23.0399 34.5341 23.097 34.5167 23.1596C34.4993 23.2223 34.4985 23.2884 34.5142 23.3515C34.5299 23.4145 34.5616 23.4725 34.6063 23.5197L34.9327 23.8573C33.2076 25.4435 31.3073 26.8279 29.2686 27.9835C26.7259 29.425 23.9898 30.4949 21.1438 31.1606Z",
    fill: "url(#paint6_linear_2633_7616)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1185 23.2646C29.1158 22.0228 28.6206 20.8328 27.7416 19.9557C26.8625 19.0786 25.6715 18.586 24.4297 18.586C23.1879 18.586 21.9969 19.0786 21.1178 19.9557C20.2388 20.8328 19.7436 22.0228 19.7409 23.2646C19.9969 29.4851 28.8635 29.4833 29.1185 23.2646ZM24.0546 22.4506L24.0546 20.1287C24.0544 20.0794 24.064 20.0305 24.0828 19.9848C24.1016 19.9392 24.1292 19.8977 24.164 19.8627C24.1989 19.8278 24.2403 19.8 24.2859 19.7811C24.3315 19.7622 24.3803 19.7524 24.4297 19.7524C24.4791 19.7524 24.5279 19.7622 24.5735 19.7811C24.6191 19.8 24.6605 19.8278 24.6954 19.8627C24.7302 19.8977 24.7578 19.9392 24.7766 19.9848C24.7954 20.0305 24.805 20.0794 24.8048 20.1287V22.4506C24.9989 22.5397 25.1546 22.6954 25.2437 22.8895H26.8154C26.9139 22.891 27.0079 22.9311 27.077 23.0013C27.1462 23.0715 27.185 23.1661 27.185 23.2646C27.185 23.3631 27.1462 23.4577 27.077 23.5279C27.0079 23.5981 26.9139 23.6382 26.8154 23.6397H25.2437C25.1835 23.7716 25.0924 23.8869 24.9779 23.9759C24.8635 24.0649 24.7293 24.1248 24.5866 24.1506C24.444 24.1763 24.2972 24.1672 24.1589 24.1239C24.0206 24.0806 23.8948 24.0045 23.7923 23.902C23.6898 23.7995 23.6137 23.6737 23.5704 23.5354C23.5271 23.3971 23.518 23.2503 23.5438 23.1077C23.5695 22.965 23.6295 22.8308 23.7184 22.7164C23.8074 22.6019 23.9227 22.5108 24.0546 22.4506Z",
    fill: "url(#paint7_linear_2633_7616)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6149 23.2641C24.6138 23.2157 24.5939 23.1696 24.5592 23.1357C24.5246 23.1019 24.4781 23.0829 24.4297 23.0829C24.3813 23.0829 24.3347 23.1018 24.3001 23.1357C24.2655 23.1696 24.2455 23.2157 24.2445 23.2641C24.244 23.2888 24.2484 23.3133 24.2574 23.3362C24.2665 23.3591 24.28 23.38 24.2973 23.3977C24.3145 23.4153 24.3351 23.4293 24.3579 23.4389C24.3806 23.4484 24.405 23.4533 24.4297 23.4533C24.4543 23.4533 24.4787 23.4484 24.5015 23.4389C24.5242 23.4293 24.5448 23.4153 24.562 23.3977C24.5793 23.3801 24.5929 23.3592 24.6019 23.3362C24.611 23.3133 24.6154 23.2888 24.6149 23.2641Z",
    fill: "url(#paint8_linear_2633_7616)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2633_7616",
    x: 0,
    y: 0.169922,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2633_7616"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2633_7616",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2633_7616",
    x1: 35.4099,
    y1: 40.5207,
    x2: 30.7017,
    y2: 39.7062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8731E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2633_7616",
    x1: 39.5211,
    y1: 41.0175,
    x2: 34.7721,
    y2: 40.3279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8731E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2633_7616",
    x1: 27.1838,
    y1: 39.5271,
    x2: 22.6877,
    y2: 38.2673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8731E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2633_7616",
    x1: 23.0726,
    y1: 39.044,
    x2: 18.8953,
    y2: 37.3688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8731E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2633_7616",
    x1: 31.2955,
    y1: 40.0239,
    x2: 26.663,
    y2: 39.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8731E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2633_7616",
    x1: 37.8024,
    y1: 39.6726,
    x2: 37.558,
    y2: 37.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8731E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2633_7616",
    x1: 36.7931,
    y1: 35.2251,
    x2: 19.8738,
    y2: 23.2467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8731E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2633_7616",
    x1: 27.9121,
    y1: 31.0229,
    x2: 16.6097,
    y2: 26.6152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8731E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2633_7616",
    x1: 24.5672,
    y1: 23.576,
    x2: 24.1203,
    y2: 23.4023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8731E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockList);
export default __webpack_public_path__ + "static/media/clockList.875903b1220ba049900bb4d37e54ded8.svg";
export { ForwardRef as ReactComponent };